module.exports = __webpack_public_path__ + "static/media/ybitan.3c2a3601.png";